import React, {Component} from 'react';
import {
  Badge,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
  FormGroup
} from 'reactstrap';
import {Link} from 'react-router-dom';
import Grid from '../../../../components/Grid/';
import {api} from '../../../../constants';
import SurveyView from '../modals/SurveyView';
import {
  getSurveyEntries as APIGetSurveyEntries,
  getSurvey as APIGetSurvey
} from '../../../../gateways/surveys';

class SurveyResponse extends Component {

  constructor(props) {
    super(props);

    let currentPage = 1;

    this.state = {
      data: [],
      survey: null,
      currentPage: currentPage,
      limit: 20,
      total: 0,
      filters: {
        hotel: ""
      },
      row: {
        id: null,
        hotel: ""
      }
    };

    this.onSubmitFilters = this.onSubmitFilters.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.toggle = this.toggle.bind(this);
    this.fetchData = this.fetchData.bind(this);
  }

  componentWillMount() {
    APIGetSurvey(this.props.id).then((result) => {
      if ( !result.error ) {
        if ( result.data != null ) {
          this.setState({
            "survey": result.data
          }, () => {
            this.fetchData();
          });
        }
      }
    });
  }

  fetchData() {
    APIGetSurveyEntries(this.props.id, { limit: this.state.limit, page: this.state.currentPage, ...this.state.filters })
    .then(result => {

      let surveyEntries = result.data.survey_entries;
      surveyEntries.forEach((surveyEntry) => {
        surveyEntry['hotel'] = surveyEntry.Hotel.propertyname;
        surveyEntry['phone'] = surveyEntry.Hotel.phone;
        surveyEntry['contact_name'] = surveyEntry.Hotel.contact_name;
        surveyEntry['contact_email'] = surveyEntry.Hotel.contact_email;
      });

      this.setState({
        data: result.data.survey_entries,
        total: result.total,
        maxPage: result.pages
      });
    });
  }

  viewSurvey(row) {
    this.setState({
      row: row
    }, this.toggle);
  }

  getGridButtons(row) {
    return (
      <div>
        <Button className="btn btn-sm" onClick={(e) => { e.preventDefault(); this.viewSurvey(row) }}><i className="fa fa-eye"></i>&nbsp;View</Button>
      </div>
    );
  }

  renderStaticField(label, value) {
    return (
      <FormGroup row>
        <Col md="4">
          <strong>{label}</strong>
        </Col>
        <Col xs="12" md="8">
          <p className="form-control-static">{value}</p>
        </Col>
    </FormGroup>
    );
  }

  onSubmitFilters(filters) {
    this.setState({
      currentPage: 1,
      filters: {
        hotel: filters.hotel
      }
    }, this.fetchData);
  }

  onChangePage(page) {
    this.setState({
      currentPage: page
    }, this.fetchData);
  }

  toggle() {
    this.setState({
      isModalOpen: !this.state.isModalOpen
    });
  }

  render() {
    let url = this.state.url;
    let columns = [{
        key: "tools",
        type: "custom",
        render: (row) => this.getGridButtons(row),
        width: "150px"
      },
      {
        key: "hotel",
        type: "string",
        name: "Hotel",
        minWidth: "150px"
      },
      {
        key: "phone",
        type: "string",
        name: "Phone",
        minWidth: "150px"
      },
      {
        key: "contact_name",
        type: "string",
        name: "Contact Name",
        minWidth: "150px"
      },
      {
        key: "contact_email",
        type: "string",
        name: "Contact Email",
        minWidth: "150px"
      },
      {
        key: "status",
        type: "string",
        name: "Submitted",
        query: {
          submitted: "Yes",
          unsubmitted: "No"
        }
      }
    ];

    let filter = {
      fields: [
        {
          "id": "hotel",
          "text": "Hotel",
          "type": "text"
        }
      ]
    };

    return (
      <div className="animated fadeIn">
        <Row>
          <Col xs="12">
            <Card>
              <CardBody>
                {
                  this.state.survey &&
                  <Row>
                    <Col xs="12">
                      <Row>
                        <Col xs="6">
                          {this.renderStaticField("Survey Name", this.state.survey.name)}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                }
                <Grid
                  columns={columns}
                  filter={filter}
                  onSubmitFilters={this.onSubmitFilters}
                  onChangePage={this.onChangePage}
                  data={this.state.data}
                  currentPage={this.state.currentPage}
                  perPage={this.state.limit}
                  total={this.state.total} />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <SurveyView
          toggle={this.toggle}
          isOpen={this.state.isModalOpen}
          id={this.state.row.id}
          title={`Response from "${this.state.row.hotel}"`} />
      </div>
    )
  }
}

export default SurveyResponse;



// WEBPACK FOOTER //
// ./src/views/Surveys/View/tabs/SurveyResponse.js